module.exports = __webpack_public_path__ + "img/MasterThief.f90de5b0.png";